export async function getConfigInfo(url)
{
    return await fetch(url, {
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
        }
        })
        .then(response => {
            return response.json();
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export default getConfigInfo;